import './RestoreUsersTableButton.scss';
import {useContext, useState} from "react";
import {Button} from "../Form/Button/Button";
import {buttonColors} from "../Pickers/InputTheme";
import {GridReactContext} from "../../Utils/DataGridWrapper/GridContext";
import {I18nReactContext} from "../../contexts/I18nContext";
import RestoreIcon from '@mui/icons-material/Restore';
import {RestoreUserConfirmationModal} from "./RestoreUserConfirmationModal/RestoreUserConfirmationModal";

/**
 * Bulk-restore button rendered inside a DataGrid's `buttons[]` slot.
 *
 * Reads the current row selection from `GridReactContext`, disables itself when nothing
 * is selected, and opens the confirmation modal. On successful restore it clears the
 * selection, triggers a table refresh, and forwards to the caller's `onSuccess`.
 *
 * @param {Object} props
 * @param {Function} [props.onSuccess] - Optional callback fired after a successful restore.
 * @returns {JSX.Element}
 */
export const RestoreUsersTableButton = ({onSuccess}) => {
    const {i18n} = useContext(I18nReactContext);
    const gridContext = useContext(GridReactContext);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onClick = () => {
        setIsModalOpen(true);
    };

    const onModalClose = () => {
        setIsModalOpen(false);
    };

    const onModalSuccess = () => {
        setIsModalOpen(false);
        gridContext.setSelectionModelToContext([]);
        gridContext.triggerTableRefresh();
        if (onSuccess) {
            onSuccess();
        }
    };

    const selectionEmpty = !gridContext.selectionModel || gridContext.selectionModel.length === 0;

    return <div className="RestoreUsersTableButton">
        <Button
            data-testid="restore-users-button"
            disabled={selectionEmpty}
            color={buttonColors.GREY}
            icon={<RestoreIcon/>}
            onClick={onClick}
            text={i18n.translate('deletedUsersPage.buttons.restoreUsers')}
        />
        {isModalOpen && (
            <RestoreUserConfirmationModal
                open={isModalOpen}
                onClose={onModalClose}
                onSuccess={onModalSuccess}
            />
        )}
    </div>;
};
